import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { LMCaptchaControlService } from '@field/captchacontrol/lm-captcha-control.service';

@Component({
  selector: 'lm-captcha-control',
  templateUrl: 'lm-captcha-control.component.html',
  styleUrls: [ 'lm-captcha-control.component.scss' ]
})
export class LMCaptchaControlComponent implements OnInit {
  public captchaBase64Url: string;
  public isValid: boolean;

  @Input() layoutObject: LMCaptchaControl;

  @HostBinding('class.align-right') isRightAlign;
  @HostBinding('class.align-center') isCenterAlign;
  @HostBinding('class.parent-is-paragraph') @Input() parentIsParagraph: boolean;

  constructor(private lmCaptchaControlService: LMCaptchaControlService) {}

  ngOnInit() {
    this.load();
  }

  public set captchaValue(value: string) {
    this.lmCaptchaControlService.setCaptchaValue(value);
  }

  private load(): void {
    this.isCenterAlign = this.layoutObject.alignCenter;
    this.isRightAlign = this.layoutObject.alignRight;
    this.lmCaptchaControlService.getCaptchaBase64Url().then((url) => this.captchaBase64Url = url);
  }

  public reload() {
    this.load();
  }
}
